/*
 * @Description: 
 * @Author: liangziyao
 * @Date: 2021-09-01 17:28:28
 */
export default {
  '-20001': '未登录',
  '-20002': '參數錯誤',
  '-20003': '已經綁定過了',
  '-20004': '未綁定角色',
  '-20005': '您已簽到',
  '-20006': '領獎失敗，請稍後再試',
  '-20007': '簽到未滿三天',
  '-20008': '您已領取',
  '-20009': '抽獎次數不足',
  '-20015': '活動未開始',
  '-20016': '活動已結束',
  '-20100': '您的操作太頻繁，請稍後再試',
}
